import { LinkOffIcon as LinkOff } from "@l2r-front/l2r-icons"
import {
    Button as UiButton,
    Skeleton as UiSkeleton,
    Typography as UiTypography,
    styled,
    styledForMobile,
} from "@l2r-front/l2r-ui"

export const Skeleton = styled(UiSkeleton)({
    height: 24,
    transform: "scale(1)",
    width: 220,
})

export const RoadDetailWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(5, 8, 8, 8),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
}))

export const Wrapper = styledForMobile("div")(({ isMobile, theme }) => ({
    backgroundColor: theme.palette["common/gray_states"].light,
    display: "flex",
    flexDirection: "column",
    height: "fit-content",
    flex: 1,
    padding: isMobile ? theme.spacing(5) : theme.spacing(8),
}))

export const Container = styledForMobile("div")(({ isMobile }) => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: !isMobile && "auto",
}))

export const ErrorText = styled(UiTypography)(({ theme }) => ({
    color: theme.palette["error"].main,
    marginTop: theme.spacing(5),
}))

export const CampaignsWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(5),
    gap: theme.spacing(2),
}))

export const CampaignItem = styled("div")(({ theme }) => ({
    maxWidth: "100%",
    display: "flex",
    justifyContent: "flex-start",
    gap: theme.spacing(4),
    height: 24,
}))

export const CampaignButton = styled(UiButton)(() => ({
    color: "inherit",
    display: "flex",
    justifyContent: "flex-start",
    width: "fit-content",
    padding: 0,
}))

export const ColorContainer = styled("div")(() => ({
    backgroundColor: "white",
    borderRadius: 4,
    height: 24,
    width: 24,
    minWidth: 24,
    overflow: "hidden",
}))

export const Color = styled("div", { shouldForwardProp: (prop) => prop !== "color" && prop !== "disabled" })(({ color, disabled }) => ({
    backgroundColor: color,
    opacity: disabled ? 0.5 : 1,
    width: "100%",
    height: "100%",
}))

export const LinkOffIcon = styled(LinkOff)(() => ({
    height: 18,
    width: 18,
}))

export const CampaignName = styled(UiTypography, { shouldForwardProp: (prop) => prop !== "disabled" })(({ theme, disabled }) => ({
    marginLeft: theme.spacing(2),
    textDecoration: "underline",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: disabled ? theme.palette["text/disabled"].main : "inherit",
}))